import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { ApiResponse } from 'src/app/models/IApiResponse';
import { BillsOfLadingService } from 'src/app/services/bills-of-lading/bills-of-lading.service';
import { AddConsolidatedEntryService } from 'src/app/services/entries/add-consolidated-entry.service';
import { GlobalService } from 'src/app/services/shared/global.service';
import { PendingTasksHandler } from 'src/app/shared/pending-tasks-handler';

@Component({
  selector: 'app-add-consolidated-entry',
  templateUrl: './add-consolidated-entry.component.html',
  styleUrls: ['./add-consolidated-entry.component.css']
})
export class AddConsolidatedEntryComponent implements OnInit{
  inProgress: boolean = false;
  public bl_id: string | null = null;
  public errorMessage: string | null = null;
  public successMessage: string | null = null;
  public warningMessage: string | null = null;
  billsOfLading: any[] = [];
  public bl_data:any;
  vehicles: any[] = [];
  form!: FormGroup;
  submitted: boolean = false;
  bl_number:string='';
  selectedBL!: string;
  entryFileName: string="Choose a PDF file";
  pmtSlipFileName: string="Choose a PDF file";
  entry_attachment: any;
  pmt_slip_attachment: any;
  public entryNo: string = '';
  public docRefNo: string = '';
  isProcessing: boolean = false;

  constructor(
    private billsOfLadingService: BillsOfLadingService,
    private formBuilder: FormBuilder,
    private addConsolidatedEntryService: AddConsolidatedEntryService,
    private globalService: GlobalService,
    private pendingTasksHandler: PendingTasksHandler,
    private router: Router,
  ){
    this.form = this.formBuilder.group({
      entry_no: ['', Validators.required],
      entry_date: ['', Validators.required],
      duty_amount: ['', Validators.required],
      entry_attachment: [null, Validators.required],
      pmt_slip_attachment: [null, Validators.required],
      doc_ref_no: ['', Validators.required],
      payment_ref_no: ['', Validators.required],
      has_rad: [false],
      has_idf: [false],
    });
  }

  ngOnInit(): void {
    this.inProgress=true;
    this.fetchBLs();
  }

  fetchBLs():void {
    this.addConsolidatedEntryService.getBLPendingEntry().subscribe({
      next: (response) => {
        if(response.status=='success'){
          this.billsOfLading = response.data
          this.inProgress=false;
        }else{
          this.warningMessage = "No BLs found!"
          this.inProgress=false;
        }
      },
      error: (error) => {
        this.errorMessage=error;
        this.inProgress=false;
      }
    });
  }

  onSelectChange() {
    if(this.selectedBL!=='' && this.selectedBL!==null){
      this.errorMessage=null;
      this.inProgress=true;
      this.getBLData(this.selectedBL);
    }else{
      this.errorMessage="Please select BL to proceed!";
      this.vehicles=[];
      this.bl_data=null;
    }
  }

  /**
   * Get single BL info
   * @param bl_id
   */
  getBLData(bl_id: string): void {
    this.billsOfLadingService.viewBL(bl_id)
    .subscribe({
      next: (response) => {
        if (response && Object.keys(response).length === 0) {
          this.inProgress=false;
          this.errorMessage="Oops! A problem was encountered while processing your request. Please refresh the page and try again!";
        }else{
          this.bl_data = response;

          if(this.bl_data.status==='no_data' || this.bl_data.status.length===0){
            this.errorMessage=this.bl_data.message;
            this.inProgress=false;
          }else{
            //Load vehicles
            this.getVehiclesByBL(this.bl_data.data.bl_no);

            this.bl_number=this.bl_data.data.bl_no;

          }
        }
      },
      error: (error) => {
        this.errorMessage=error;
        this.inProgress=false;
      }
    });
  }

  /**
   * Get vehicles associated with the selected BL
   * @param bl_no
   */
  getVehiclesByBL(bl_no: string): void {
    this.billsOfLadingService.getVehicles(bl_no).subscribe((response: ApiResponse) =>{
      if(response.status==='success'){
        this.inProgress=false;
        this.vehicles = response.data
      }else{
        this.inProgress=false;
        this.warningMessage="No vehicles associated with this BL were found!";
      }
    });
  }

  /**
   * Handle selectd file
   * @param event
   */
  onEntryFileSelected(event: any) {
    //Show selected file
    const fileInput = event.target as HTMLInputElement;
    this.entryFileName = fileInput.files?.[0]?.name ?? 'Choose a PDF file';

    //Prepare file for upload
    if (event.target.files && event.target.files.length) {
      const [file] = event.target.files;
      this.entry_attachment = file
    }
  }

  /**
   * Handle selectd file
   * @param event
   */
  onPaymentSlipFileSelected(event: any) {
    //Show selected file
    const fileInput = event.target as HTMLInputElement;
    this.pmtSlipFileName = fileInput.files?.[0]?.name ?? 'Choose a PDF file';

    //Prepare file for upload
    if (event.target.files && event.target.files.length) {
      const [file] = event.target.files;
      this.pmt_slip_attachment = file
    }
  }

  /**
   * Copy Entry No. and generate Document Reference No.
   */
  copyEntryNo():void {
    this.docRefNo=this.entryNo+"-1"
  }

  /**
   * Save entry
   */
  handleSubmit() {
    this.submitted = true;
    this.isProcessing=true;

    if (this.form.valid) {
      this.addConsolidatedEntryService.addEntry(this.form.value,this.entry_attachment,this.pmt_slip_attachment,this.bl_number)
      .subscribe({
        next: (response) => {
          if(response.status==='success'){
            this.submitted = false;
            this.globalService.setGlobalSuccessMessage(response.message);
            //Count the remaining unpaid duties
            this.pendingTasksHandler.numberOfPendingDutyPayments();
            // Redirect to unpaid duties list
            this.router.navigate(['unpaid-duties']);
          }else if(response.status==='upload_error'){
            this.submitted = false;
            //Count the remaining unpaid duties
            this.pendingTasksHandler.numberOfPendingDutyPayments();
            this.globalService.setGlobalWarningMessage(response.message);
           // Redirect to unpaid duties list
           this.router.navigate(['unpaid-duties']);
          }else{
            this.submitted = false;
            this.isProcessing=false;
            this.errorMessage=response.message;
          }
        },
        error: (error) => {
          this.submitted = false;
          this.isProcessing=false;
          this.errorMessage=error;
        }
      });
    }else{
      this.isProcessing=false;
    }
  }
}
